module.exports = __webpack_public_path__ + "img/device_logo_small.d67e8084.png";